export const rolePaths = {
  admin: "/admin/courses",
  trainer: "/trainer/dashboard",
  center_manager: "/center-manager/dashboard",
  learner: "/learner/dashboard",
};